import { reactive } from "@vue/reactivity"
import { postSkillPathQuery } from "@/api";
import { ApiSkillPathOrderByEnum, ApiSkillPathMediaMenuEnum } from "@/enums/api/index";

const states = reactive({
    list: null,
})

const getters = {
    currentSkillPathDetail: (urlName) => {
        const findItem = states.list?.items?.filter(item => item.urlName === urlName) ?? [];
        if (findItem.length === 0) {
            return null;
        }
        return { count: states.list.count, items: findItem };
    }
}

const mutations = {
    updateSkillPathList: data => {
        states.list = data;
    },
}

const actions = {
    skillPathQuery: params => {
        const apiOptions = {
            "urlName": "",
            "MediaMenu": ApiSkillPathMediaMenuEnum.ALL,
            "orderBy": ApiSkillPathOrderByEnum.LATEST,
            ...params
        }
        return postSkillPathQuery(apiOptions)
    },
    getSkillPathList: (params) => {
        return new Promise((resolve,reject) => {
            const currentDetail = getters.currentSkillPathDetail(params.urlName);

            if (currentDetail) {
                resolve(currentDetail);
            } 
            else {
                actions.skillPathQuery(params).then(res => {
                    mutations.updateSkillPathList(res);
                    resolve(res)
                }).catch((res) => {
                    reject(res)
                })
            }
        })
    }
}

export default {
    states,
    getters,
    mutations,
    actions
}